export default __webpack_public_path__ + "static/catear-096141b89bb5b28bbbcc3d9ae33dda04.png";